module.exports = __webpack_public_path__ + "img/John Rogers.d4926ff2.jpg";